// extracted by mini-css-extract-plugin
module.exports = {"pagination":"MainSlider_pagination__VE6GJ","page":"MainSlider_page__2AuHk","page_current":"MainSlider_page_current__Zmdbk","pageCurrent":"MainSlider_page_current__Zmdbk"};
    if(module.hot) {
      // 1586964020928
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  